// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cart"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 2H4L7 13L6 17H21M7 21C7 21.5523 6.55228 22 6 22C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20C6.55228 20 7 20.4477 7 21ZM21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 20.4477 19.4477 20 20 20C20.5523 20 21 20.4477 21 21ZM6.99947 13H18.9995L21.9995 4H4.54492L6.99947 13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CartIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cart',
    ref,
    icon: element,
  },
));

CartIcon.displayName = 'CartIcon';

export default CartIcon;
